import { FC } from 'react'
import { Dialog, DialogContent, DialogActions, IconButton } from '@material-ui/core'
import { fullSizeDialogStyle } from './FullSizeDialog.style'
import { useIntl } from 'react-intl'
import { WikiService } from 'src/dataSources/wiki/Wiki'
import { Close } from '@material-ui/icons'

/**
 * FullSizeDialogProps contains properties for the component.
 */
export interface FullSizeDialogProps {
  open: boolean
  imageKey: string
  handleClose: () => void
}

/**
 * FullSizeDialog displays an image in its original size up to a max width
 * @param props Properties for component.
 * @returns JSX component.
 */
export const FullSizeDialog: FC<FullSizeDialogProps> = (props: FullSizeDialogProps) => {
  const classes = fullSizeDialogStyle()
  const intl = useIntl()

  const wikiService = new WikiService()

  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      classes={{ paper: classes.root }}
      maxWidth='xl'
    >
      <DialogContent className={classes.content}>
        <img src={wikiService.getImageUrl(props.imageKey)} alt={intl.formatMessage({ id: 'wiki.content.image' })} />
      </DialogContent>
      <DialogActions className={classes.actions}>
        <IconButton
          className={classes.closeButton}
          size='small'
          onClick={props.handleClose}
        >
          <Close />
        </IconButton>
      </DialogActions>
    </Dialog>
  )
}

export default FullSizeDialog
